import { createFileRoute } from '@tanstack/react-router';
import { queryClient } from '@/lib/utils/queryClient';
import { CompanyPlatformFeaturesTab } from '../../../-components/CompanyPlatformFeaturesTab';
import { companyPlatformFeaturesQueryOptions } from '../../../-hooks/useCompanyPlatformFeatures';

export const Route = createFileRoute(
  '/management/companies/(pages)/$companyId/platform-features/',
)({
  loader: ({ params }) =>
    queryClient
      .ensureQueryData(companyPlatformFeaturesQueryOptions(params.companyId))
      // A failed prefetch must not blank the tab — the component's own query
      // re-runs and surfaces the error inline.
      .catch(() => undefined),
  component: CompanyPlatformFeaturesPage,
});

function CompanyPlatformFeaturesPage() {
  const { companyId } = Route.useParams();
  return <CompanyPlatformFeaturesTab companyId={companyId} />;
}
